import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';

export default function PrivacyPolicy() {
  return (
    <Stack sx={{ py: '64px', px: '140px', gap: 0.5 }}>
      <Typography fontSize="32px" fontWeight={700}>
        Privacy Policy
      </Typography>
      <Typography fontSize="14px" fontWeight={500}>
        At{' '}
        <Typography component="span" fontSize="14px" fontWeight={700}>
          Modvise Sp. z o.o.
        </Typography>
        , we respect your privacy. This Privacy Policy explains how we handle
        information in <br /> relation to our application{' '}
        <Typography component="span" fontSize="14px" fontWeight={700}>
          Media Calculator
        </Typography>
        , accessible via https://mediacalculator.pl, which interacts with <br />
        Meta (Facebook) Marketing APIs.
      </Typography>
      <Typography fontSize="18px" fontWeight={700}>
        1. Information We Do Not Collect
      </Typography>
      <Typography fontSize="14px" fontWeight={500}>
        Media Calculator{' '}
        <Typography component="span" fontSize="14px" fontWeight={700}>
          does not collect, store, or process any personal information
        </Typography>{' '}
        from Facebook users.
      </Typography>
      <Typography fontSize="14px" fontWeight={500}>
        Specifically:
      </Typography>
      <List dense>
        <ListItem disableGutters disablePadding>
          <ListItemIcon sx={{ minWidth: '20px', mt: '2px', pl: 1 }}>
            •
          </ListItemIcon>
          <ListItemText
            primary="We do not collect or access names, email addresses, birthdays, locations, or any other personally identifiable data."
            primaryTypographyProps={{ fontSize: '14px', fontWeight: 500 }}
          />
        </ListItem>
        <ListItem disableGutters disablePadding>
          <ListItemIcon sx={{ minWidth: '20px', mt: '2px', pl: 1 }}>
            •
          </ListItemIcon>
          <ListItemText
            primary="We do not use Facebook Login or request user profile permissions."
            primaryTypographyProps={{ fontSize: '14px', fontWeight: 500 }}
          />
        </ListItem>
      </List>
      <Typography fontSize="18px" fontWeight={700}>
        2. Use of Meta (Facebook) APIs
      </Typography>
      <Typography>
        Our app uses the{' '}
        <Typography component="span" fontSize="14px" fontWeight={700}>
          Meta Marketing API
        </Typography>{' '}
        solely for the purpose of:
      </Typography>
      <List dense>
        <ListItem disableGutters disablePadding>
          <ListItemIcon sx={{ minWidth: '20px', mt: '2px', pl: 1 }}>
            •
          </ListItemIcon>
          <ListItemText
            primary="Estimating advertising reach,"
            primaryTypographyProps={{ fontSize: '14px', fontWeight: 500 }}
          />
        </ListItem>
        <ListItem disableGutters disablePadding>
          <ListItemIcon sx={{ minWidth: '20px', mt: '2px', pl: 1 }}>
            •
          </ListItemIcon>
          <ListItemText
            primary="Simulating ad campaigns,"
            primaryTypographyProps={{ fontSize: '14px', fontWeight: 500 }}
          />
        </ListItem>
        <ListItem disableGutters disablePadding>
          <ListItemIcon sx={{ minWidth: '20px', mt: '2px', pl: 1 }}>
            •
          </ListItemIcon>
          <ListItemText
            primary=" Reserving campaigns for later activation by the user through their own
        business account."
            primaryTypographyProps={{ fontSize: '14px', fontWeight: 500 }}
          />
        </ListItem>
      </List>

      <Typography fontSize="18px" fontWeight={700}>
        3. Cookies and Tracking
      </Typography>
      <Typography fontSize="14px" fontWeight={500}>
        Our application{' '}
        <Typography component="span" fontSize="14px" fontWeight={700}>
          does not use cookies
        </Typography>{' '}
        or any form of tracking technologies to collect user behavior or data.
      </Typography>
      <Typography fontSize="18px" fontWeight={700}>
        4. Data Sharing
      </Typography>
      <Typography fontSize="14px" fontWeight={500}>
        Since we do not collect any user data, there is{' '}
        <Typography component="span" fontSize="14px" fontWeight={700}>
          no data shared with third parties
        </Typography>
        .
      </Typography>
      <Typography fontSize="18px" fontWeight={700}>
        5. Data Security
      </Typography>
      <Typography fontSize="14px" fontWeight={500}>
        As we do not store or transmit any personal data, no data storage or
        encryption mechanisms are used for such data.
      </Typography>
      <Typography fontSize="18px" fontWeight={700}>
        6. Contact Information
      </Typography>
      <Typography fontSize="14px" fontWeight={500}>
        If you have any questions about this Privacy Policy, please contact us
        at:
      </Typography>
      <Typography component="span" fontSize="14px" fontWeight={700}>
        Modvise Sp. z o.o.
      </Typography>
      <Typography fontSize="14px" fontWeight={500}>
        ul. Jana Pawła Woronicza 33C/59
      </Typography>
      <Typography fontSize="14px" fontWeight={500}>
        02-640 Warszawa, Poland
      </Typography>
      <Typography fontSize="14px" fontWeight={500}>
        📧 legal@modvise.com
      </Typography>
    </Stack>
  );
}
